var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.834C21.933 32.834 23.5 31.267 23.5 29.334C23.5 27.401 21.933 25.834 20 25.834C18.067 25.834 16.5 27.401 16.5 29.334C16.5 31.267 18.067 32.834 20 32.834Z",
    fill: "#737A83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 28.167V18.192C11.25 13.397 15.1467 9.50032 19.9417 9.50032H20.0583C24.8533 9.50032 28.75 13.397 28.75 18.192V28.167H11.25Z",
    fill: "#E7ECEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 27.001H10.6667C10.0223 27.001 9.5 27.5233 9.5 28.1676C9.5 28.812 10.0223 29.3343 10.6667 29.3343H29.3333C29.9777 29.3343 30.5 28.812 30.5 28.1676C30.5 27.5233 29.9777 27.001 29.3333 27.001Z",
    fill: "#E7ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3327 9.50033C22.3327 8.21166 21.288 7.16699 19.9993 7.16699C18.7107 7.16699 17.666 8.21166 17.666 9.50033V11.8337C17.666 13.1223 18.7107 14.167 19.9993 14.167C21.288 14.167 22.3327 13.1223 22.3327 11.8337V9.50033Z",
    fill: "#E7ECEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/alarm_icon.a3f6c87a42b415c20840fbc444d962d8.svg";
export { ForwardRef as ReactComponent };